const address = `
    id
    firstname
    lastname
    street
    city
    region {
        region_code
        region
    }
    postcode
    country_code
    country_name
    telephone
    default_shipping
    default_billing
`;

const createCustomerAddress = `
    mutation CreateCustomerAddress($input: CustomerAddressInput!) {
        createCustomerAddress(input: $input) {
            ${address}
        }
    }
`;

const updateCustomerAddress = `
    mutation UpdateCustomerAddress($id: Int!, $input: CustomerAddressInput!) {
        updateCustomerAddress(id: $id, input: $input) {
            ${address}
        }
    }
`;

const addresses = `{
    customer {
        addresses {
           ${address}
        }
    }
}`;

const deleteCustomerAddress = `
    mutation DeleteCustomerAddress($id: Int!) {
        deleteCustomerAddress(id: $id)
    }
`;

export default {
    addresses,
    createCustomerAddress,
    updateCustomerAddress,
    deleteCustomerAddress,
};
